<script lang="ts">
  import Heading from "../atoms/Heading.svelte";
  import PriceInfo from "../atoms/PriceInfo.svelte";
  import Specification from "../atoms/Specification.svelte";
  import format from "date-fns/format";
  import sv from "date-fns/locale/sv";
  import Link from "../atoms/Link.svelte";
  import { useFetchProduct } from "../../helpers/api";
  import Error from "../molecules/Error.svelte";
  import Card from "../atoms/Card.svelte";
  import Loader from "../atoms/Loader.svelte";
  import Addons from "../molecules/Addons.svelte";
  import { onMount } from "svelte";

  interface Props {
    changeProduct: () => void;
    toggleAddonProduct: (id: number) => void;
    selectedAddons: number[];
    isLoading: boolean;
    zipcode: string | undefined;
    campaign: string;
    selectedProductId: number;
    estimation: number;
    useBankId: boolean;
    productOfferId: number | undefined;
    hasFetchedAutomatic: boolean;
  }

  let {
    changeProduct,
    toggleAddonProduct,
    selectedAddons,
    isLoading,
    zipcode,
    campaign,
    selectedProductId,
    estimation,
    useBankId = $bindable(),
    productOfferId = $bindable(),
    hasFetchedAutomatic,
  }: Props = $props();

  onMount(() => {
    $productQuery.refetch();
  });

  const params = {
    zipcode: zipcode,
    code: campaign,
  };

  const productQuery = useFetchProduct(selectedProductId, estimation, params, {
    enabled: false,
    onSuccess: (data) => {
      useBankId = data.bankID;
      productOfferId = data.offerId;
    },
  });
</script>

{#if $productQuery.status == "error"}
  <Error
    onClick={() => {
      $productQuery.refetch();
    }}
    >Något gick fel vid hämtning av produkt
  </Error>
{:else if $productQuery.status == "loading"}
  <Card class="h-80 flex justify-center items-center">
    <Loader />
  </Card>
{:else if $productQuery.status == "success"}
  <Card class="bg-Neutral100">
    <div class=" ">
      <div class="flex justify-between">
        <Heading>{$productQuery.data.name}</Heading>
        {#if !isLoading}
          <Link onClick={() => changeProduct()}>Ändra</Link>
        {/if}
      </div>
      {#if $productQuery.data.costs && $productQuery.data.previousMonth}
        <PriceInfo
          {hasFetchedAutomatic}
          zipcode={zipcode ?? ""}
          productType={$productQuery.data.type}
          position="left"
          class="mb-4"
          previousMonth={format($productQuery.data.previousMonth, "MMMM", {
            locale: sv,
          })}
          costs={$productQuery.data.costs}
        />
      {/if}
    </div>
    <div
      class="transition-maxHeight w-full xl:flex xl:space-x-2 xl:justify-between max-h-96 duration-700"
    >
      <Specification product={$productQuery.data} expandable={false} />
    </div>
  </Card>
  {#if $productQuery.data.addons && $productQuery.data.addons.length > 0}
    <Addons addons={$productQuery.data.addons} {toggleAddonProduct} {selectedAddons} />
  {/if}
{/if}
